/* Xred: the bulk section's two moving parts, the bottle-count slider on the
   quote form and the FAQ played as a text thread (further down).
   Slider:
   The range input walks a fixed list of counts (data-steps). The big number
   runs from the old count to the new one, the tier tag swaps when the count
   crosses a tier (data-tiers, "min|label;min|label"), and the thumb and fill
   take the heat colour for how far along the scale the count is. The hidden
   input carries "144 bottles (Wholesale)" into the request. data-ticks
   picks which counts are labelled under the track.
   Shared verbatim with the theme as assets/xred-bulk.js. */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HEAT = ['#7fb03a', '#9a4a2a', '#e8702a', '#e12327'];

  function hex(h) { h = h.replace('#', ''); return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)]; }
  function heatAt(p, stops) {
    var seg = Math.min(stops.length - 2, Math.floor(p * (stops.length - 1)));
    var t = p * (stops.length - 1) - seg, a = hex(stops[seg]), b = hex(stops[seg + 1]);
    return 'rgb(' + a.map(function (v, i) { return Math.round(v + (b[i] - v) * t); }).join(',') + ')';
  }

  function mount(root) {
    if (root.dataset.qslideOn) return; root.dataset.qslideOn = '1';
    var range = root.querySelector('.qslide__range'), num = root.querySelector('.qslide__num'),
        tierEl = root.querySelector('.qslide__tier'), out = root.querySelector('.qslide__value'),
        ticks = root.querySelector('.qslide__ticks');
    if (!range || !num) return;
    var steps = (root.dataset.steps || '12,24,48,96,144,240,480').split(',').map(function (s) { return parseInt(s, 10); }).filter(function (n) { return n > 0; });
    var tiers = (root.dataset.tiers || '').split(';').map(function (t) { var p = t.split('|'); return { min: parseInt(p[0], 10) || 0, label: (p[1] || '').trim() }; }).filter(function (t) { return t.label; });
    var plus = root.dataset.plus || '+', unit = root.dataset.unit || 'bottles';
    var cs = getComputedStyle(document.documentElement);
    var stops = ['--heat-mild', '--heat-smoky', '--heat-hot', '--heat-extra'].map(function (v, i) { var x = cs.getPropertyValue(v).trim(); return /^#[0-9a-f]{6}$/i.test(x) ? x : HEAT[i]; });

    range.min = 0; range.max = steps.length - 1; range.step = 1;
    if (+range.value > steps.length - 1) range.value = Math.min(1, steps.length - 1);

    function label(n, last) { return n + (last ? plus : ''); }
    function tierFor(n) { var t = null; tiers.forEach(function (x) { if (n >= x.min) t = x; }); return t; }

    // Ticks: the counts in data-ticks (default first, middle, last), each a shortcut.
    var tickVals = (root.dataset.ticks || [steps[0], steps[Math.floor(steps.length / 2)], steps[steps.length - 1]].join(','))
      .split(',').map(function (s) { return parseInt(s, 10); }).filter(function (n) { return steps.indexOf(n) > -1; });
    if (ticks) {
      ticks.innerHTML = '';
      tickVals.forEach(function (n) {
        var i = steps.indexOf(n), s = document.createElement('span');
        s.textContent = label(n, i === steps.length - 1); s.dataset.i = i;
        s.style.left = (i / (steps.length - 1) * 100) + '%';
        s.addEventListener('click', function () { range.value = i; paint(true); range.focus(); });
        ticks.appendChild(s);
      });
    }

    var shown = steps[+range.value], raf = 0, lastTier = '';
    function run(to, last) {
      cancelAnimationFrame(raf);
      var from = shown, t0 = performance.now(), dur = reduce ? 0 : Math.min(520, 220 + Math.abs(to - from) * 1.2);
      (function tick(now) {
        var k = dur ? Math.min(1, (now - t0) / dur) : 1, e = 1 - Math.pow(1 - k, 3);
        shown = Math.round(from + (to - from) * e);
        num.textContent = label(shown, last && k === 1);
        if (k < 1) raf = requestAnimationFrame(tick);
      })(t0);
    }

    function paint(animate) {
      var i = +range.value, n = steps[i], last = i === steps.length - 1, p = steps.length > 1 ? i / (steps.length - 1) : 0;
      var heat = heatAt(p, stops), tier = tierFor(n);
      range.style.setProperty('--p', p);
      root.style.setProperty('--qs-heat', heat);
      if (animate) run(n, last); else { shown = n; num.textContent = label(n, last); }
      if (animate && !reduce) { num.classList.remove('is-bump'); void num.offsetWidth; num.classList.add('is-bump'); }
      var tl = tier ? tier.label : '';
      if (tierEl && tl !== lastTier) {
        tierEl.textContent = tl; tierEl.hidden = !tl; lastTier = tl;
        if (animate && !reduce) { tierEl.classList.remove('is-swap'); void tierEl.offsetWidth; tierEl.classList.add('is-swap'); }
      }
      if (ticks) Array.prototype.forEach.call(ticks.children, function (s) { s.classList.toggle('is-on', +s.dataset.i <= i); });
      var text = label(n, last) + ' ' + unit + (tl ? ' (' + tl + ')' : '');
      range.setAttribute('aria-valuetext', text);
      if (out) out.value = text;
    }
    range.addEventListener('input', function () { paint(true); });
    paint(false);
  }

  /* ---------------------------------------------------------- FAQ chat */
  // Builds a text thread from the FAQ's <details> list. Each question is a
  // quick reply; a tap sends it as the reader's bubble, Xred shows the typing
  // dots for a beat that scales with the answer, then the answer lands. The
  // list stays in the markup (search engines, no script) and is hidden here.
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function chat(root) {
    if (root.dataset.chatOn) return;
    var box = root.querySelector('.chat'); if (!box) return;
    var log = box.querySelector('.chat__log'), chips = box.querySelector('.chat__chips'), status = box.querySelector('.chat__who em');
    var items = Array.prototype.map.call(root.querySelectorAll('.faq__list details'), function (d) {
      var q = d.querySelector('summary'), a = d.querySelector('.faq__a');
      return q && a ? { q: q.textContent.trim(), a: a.innerHTML.trim() } : null;
    }).filter(Boolean);
    if (!items.length || !log || !chips) return;
    root.dataset.chatOn = '1';
    root.classList.add('faq--chat');
    box.hidden = false;

    var d = box.dataset, idle = status ? status.textContent : '', busy = true, started = false;
    function bottom() { log.scrollTop = log.scrollHeight; }
    function add(el) { log.appendChild(el); bottom(); return el; }
    function el(cls, html, tag) { var n = document.createElement(tag || 'div'); n.className = cls; n.innerHTML = html; return n; }
    function wait(text) { return reduce ? 0 : Math.max(650, Math.min(1900, text.replace(/<[^>]+>/g, '').length * 13)); }
    function lock(on) { busy = on; Array.prototype.forEach.call(chips.children, function (c) { c.disabled = on; }); }

    // Xred "types", then the bubble lands.
    function reply(html, then) {
      var dots = add(el('typing', '<i></i><i></i><i></i>'));
      dots.setAttribute('aria-label', d.typing || 'typing');
      if (status) { status.textContent = d.typing || 'typing'; status.classList.add('is-typing'); }
      setTimeout(function () {
        dots.remove();
        if (status) { status.textContent = idle; status.classList.remove('is-typing'); }
        add(el('msg msg--them', html));
        if (then) then();
      }, wait(html));
    }

    function ask(i, chip) {
      if (busy) return;
      lock(true);
      chip.classList.add('is-gone');
      setTimeout(function () { chip.remove(); }, reduce ? 0 : 200);
      Array.prototype.forEach.call(log.querySelectorAll('.msg__read'), function (r) { r.remove(); });
      add(el('msg msg--me', esc(items[i].q)));
      setTimeout(function () {
        if (d.read) add(el('msg__read', esc(d.read)));
        reply(items[i].a, function () {
          lock(false);
          if (!chips.children.length && d.done) {
            lock(true);
            setTimeout(function () {
              reply('<p>' + esc(d.done) + '</p>', function () {
                if (d.doneLabel) add(el('msg msg--them msg--cta', '<a class="btn btn--accent" href="' + esc(d.doneHref || '#quote') + '">' + esc(d.doneLabel) + '</a>'));
                lock(false);
              });
            }, reduce ? 0 : 500);
          }
        });
      }, reduce ? 0 : 450);
    }

    items.forEach(function (it, i) {
      var b = el('chip-q', esc(it.q), 'button');
      b.type = 'button';
      b.addEventListener('click', function () { ask(i, b); });
      chips.appendChild(b);
    });
    if (d.day) add(el('chat__day', esc(d.day)));
    lock(true);

    // The greeting is typed the first time the chat comes into view.
    function start() {
      if (started) return; started = true;
      if (d.greeting) reply('<p>' + esc(d.greeting) + '</p>', function () { lock(false); }); else lock(false);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); start(); } }, { threshold: 0.35 });
      io.observe(box);
    } else start();
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-qslide]'), mount);
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-faq-chat]'), chat);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
